import React from 'react';
import { Button, Tooltip } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

interface BulkUploadButtonProps {
  redirectPath: string;
}

const BulkUploadButton: React.FC<BulkUploadButtonProps> = ({ redirectPath }) => {
  const navigate = useNavigate();

  return (
    <Tooltip title="Bulk Upload">
      <Button
        shape="circle"
        icon={<UploadOutlined />}
        onClick={() => navigate(redirectPath)}
      />
    </Tooltip>
  );
};

export default BulkUploadButton;